import '@fontsource/roboto';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LicenseInfo } from '@mui/x-license-pro';
import {
  AuthorizationService,
  DataAccessService,
  DataLoadService,
  EventService,
  getBrowserAuthClients,
} from '@price-for-profit/micro-services';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { MUI_LICENSE_KEY } from 'shared/constants';
import {
  ProvideAuth,
  ProvideErrorBoundary,
  ProvideQueryClient,
  ProvideService,
  ProvideSnackbar,
  ProvideTheme,
  ServiceContext,
} from 'shared/providers';
import {
  CustomerCommodityService,
  FreightService,
  PdfUploadService,
  ProductService,
  UserMappingService,
  WpsEventService,
} from 'shared/service';
import { getAppConfig } from 'startup/get-app-config';
import { registerGoogleAnalytics } from 'startup/register-google-analytics';
import App from './App';
import './index.css';

//import reportWebVitals from './reportWebVitals';
const run = async () => {
  const baseUrl = process.env.PUBLIC_URL;
  const appConfig = await getAppConfig(baseUrl);
  const { clientApp, httpClient } = getBrowserAuthClients({
    clientId: appConfig.appId,
    authDomainHost: appConfig.authDomainHost,
    authorityUrl: appConfig.authorityUrl,
    cacheLocation: 'localStorage',
    serviceBaseUrl: appConfig.serviceBaseUrl,
    clientScopes: {
      das: appConfig.dataAccessAppId,
      docs: appConfig.documentAppId,
      lookup: appConfig.lookupAppId,
      event: appConfig.eventAppId,
      auth: appConfig.authAppId,
      'data-load': appConfig.dataloadAppId,
    },
  });

  LicenseInfo.setLicenseKey(MUI_LICENSE_KEY);

  const eventService = new EventService(httpClient);
  const authorizationService = new AuthorizationService(httpClient);
  const dataLoadService = new DataLoadService(httpClient);
  const dataAccessService = new DataAccessService(httpClient);

  const productService = new ProductService(dataAccessService);
  const customerCommodityService = new CustomerCommodityService(dataAccessService);
  const freightService = new FreightService(dataAccessService);
  const userMappingService = new UserMappingService(dataAccessService, authorizationService);
  const wpsEventService = new WpsEventService(eventService);
  const pdfUploadService = new PdfUploadService(dataLoadService);

  const serviceContext: ServiceContext = {
    appConfig,
    productService,
    customerCommodityService,
    userMappingService,
    wpsEventService,
    pdfUploadService,
    freightService,
  };

  if (appConfig.enableGoogleAnalytics) {
    registerGoogleAnalytics(appConfig.googleTagId);
  }

  ReactDOM.render(
    <React.StrictMode>
      <BrowserRouter basename={baseUrl}>
        <ProvideTheme>
          <ProvideSnackbar>
            <ProvideErrorBoundary>
              <ProvideService context={serviceContext}>
                <ProvideAuth clientApp={clientApp}>
                  <ProvideQueryClient>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <App />
                    </LocalizationProvider>
                  </ProvideQueryClient>
                </ProvideAuth>
              </ProvideService>
            </ProvideErrorBoundary>
          </ProvideSnackbar>
        </ProvideTheme>
      </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('root')
  );
};

run().catch(console.error);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
